define("powergen/views/admin",
  [],
  function() {
    "use strict";
    var AdminView;

    AdminView = Ember.View.extend({
      tagName: 'section',
      classNames: ['admin'],
      didInsertElement: function() {
        this.set('controller.view', this);
        return this.$('.tablesorter').tablesorter();
      }
    });


    return AdminView;
  });